import React, { useEffect, useState } from "react";
import axios from "axios";
import Cateringsettelments from "./Cateringsettelments";
import { useLoader } from "../../../context/LoaderProvider.jsx";

const Cateringaccountsdata = () => {
  const [activeTab, setActiveTab] = useState("Overview");
  const [vendorId, setVendorId] = useState(null);
  const [selectedDate, setSelectedDate] = useState("");
  const [allOrders, setAllOrders] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const { showLoader, hideLoader } = useLoader();
  const [totals, setTotals] = useState({
    totalIncome: 0,
    walletIncome: 0,
    onlineIncome: 0,
    cashIncome: 0,
  });

  // ✅ Get vendorId on mount
  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    if (storedVendorId) {
      setVendorId(storedVendorId);
    }
  }, []);

  // ✅ Fetch orders and calculate totals
  useEffect(() => {
    if (!vendorId) return;

    const token = localStorage.getItem("authToken");
    if (!token) {
      alert("Authorization token missing. Please log in again.");
      return;
    }

    showLoader();

    axios
      .get(
        `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/vendor/getall/${vendorId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        const orders = res.data || [];
        setAllOrders(orders);
        setFilteredData(orders);

        let walletIncome = 0,
          onlineIncome = 0,
          cashIncome = 0;

        // ✅ Calculate totals properly
        orders.forEach((order) => {
          const status = order.paymentStatus?.toLowerCase() || "";
          const method = order.paymentMethod?.toLowerCase() || "";
          const amount = Number(order.amountPaid || order.total || 0);

          if (status === "success" || status === "paid") {
            if (method.includes("wallet")) walletIncome += amount;
            else if (method.includes("online")) onlineIncome += amount;
            else if (method.includes("cash")) cashIncome += amount;
          }
        });

        const totalIncome = walletIncome + onlineIncome + cashIncome;
        setTotals({ walletIncome, onlineIncome, cashIncome, totalIncome });
      })
      .catch((err) => {
        console.error("Error fetching orders:", err);
        alert("❌ Failed to fetch orders. Check console for details.");
      })
      .finally(() => {
        hideLoader();
      });
  }, [vendorId]);

  // ✅ Date Filter Logic
  useEffect(() => {
    if (!selectedDate) {
      setFilteredData(allOrders);
      return;
    }

    const filtered = allOrders.filter((order) => {
      const rawDate = order.orderDateTime;
      if (!rawDate) return false;
      const dateObj = new Date(rawDate);
      if (isNaN(dateObj.getTime())) return false;
      const orderDate = dateObj.toISOString().split("T")[0];
      return orderDate === selectedDate;
    });

    setFilteredData(filtered);
  }, [selectedDate, allOrders]);

  // ✅ Export CSV
  const exportToCSV = () => {
    if (filteredData.length === 0) {
      alert("No data to export!");
      return;
    }

    const headers = [
      "S.No",
      "Order ID",
      "Date",
      "Location",
      "Payment Method",
      "Payment Status",
      "Amount",
    ];

    const rows = filteredData.map((item, index) => {
      const dateObj = new Date(item.orderDateTime);
      const dateOnly = isNaN(dateObj) ? "—" : dateObj.toLocaleDateString("en-GB");

      return [
        index + 1,
        item.orderId,
        dateOnly,
        item.location,
        item.paymentMethod,
        item.paymentStatus,
        Math.round(item.amountPaid || item.total || 0),
      ];
    });

    const csvContent = [headers, ...rows]
      .map((row) => row.map((v) => `"${v}"`).join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute(
      "download",
      `orders_${new Date().toISOString().split("T")[0]}.csv`
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // ✅ Tabs content
  const tabContent = {
    Overview: (
      <div style={{ marginTop: "20px" }}>
        {/* ✅ Income Summary Cards */}
        <div
          className="status-overview"
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-around",
          }}
        >
          {[
            { title: "Total Income", value: totals.totalIncome },
            { title: "Wallet Income", value: totals.walletIncome },
            { title: "Online Income", value: totals.onlineIncome },
            // { title: "Cash Income", value: totals.cashIncome },
          ].map((card, idx) => (
            <div
              key={idx}
              style={{
                background: "#2c6eaa",
                color: "#fff",
                borderRadius: "10px",
                padding: "15px",
                flex: "1 1 200px",
                margin: "10px",
                textAlign: "center",
              }}
            >
              <h4>{card.title}</h4>
              <p style={{ fontWeight: "bold", fontSize: "18px" }}>
                ₹{card.value.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
              </p>
            </div>
          ))}
        </div>

        {/* ✅ Filter and Export */}
        <div
          className="filter-bar"
          style={{ display: "flex", gap: "10px", justifyContent: "space-between" }}
        >
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            style={{
              background: "#b15dc6",
              color: "#fff",
              border: "none",
              padding: "6px",
              borderRadius: "5px",
            }}
          />
          <button
            onClick={exportToCSV}
            style={{
              background: "#b15dc6",
              color: "#fff",
              padding: "6px 12px",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Export CSV
          </button>
        </div>

        {/* ✅ Orders Table */}
        <div style={{ overflowX: "auto", marginTop: "20px" }} className="caetring-settlemts-data">
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "#b15dc6", color: "#fff" }}>
                <th>S.No</th>
                <th>Order ID</th>
                <th>Transaction ID</th>
                <th>Date</th>
                <th>Location</th>
                <th>Payment</th>
                <th>Status</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((item, index) => {
                  const dateObj = new Date(item.orderDateTime);
                  const dateOnly = isNaN(dateObj)
                    ? "—"
                    : dateObj.toLocaleDateString("en-GB");
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.orderId}</td>
                      <td>{item.transactionId || "—"}</td>
                      <td>{dateOnly}</td>
                      <td>{item.location || "—"}</td>
                      <td>{item.paymentMethod}</td>
                      <td>{item.paymentStatus}</td>
                      <td>₹{(item.amountPaid || item.total || 0).toFixed(2)}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center" }}>
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    ),
    Settlement: <Cateringsettelments />,
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          {Object.keys(tabContent).map((label) => (
            <button
              key={label}
              onClick={() => setActiveTab(label)}
              style={{
                backgroundColor: activeTab === label ? "#b15dc6" : "#d9d9d9",
                border: "none",
                borderRadius: "10px",
                width: "150px",
                height: "40px",
                color: "#000",
                fontWeight: "bold",
                cursor: "pointer",
                margin: "5px",
              }}
            >
              {label}
            </button>
          ))}
        </div>

        <div style={{ marginTop: "20px" }}>{tabContent[activeTab]}</div>
      </div>
    </div>
  );
};

export default Cateringaccountsdata;
